import { render, staticRenderFns } from "./directInvest_Opportunities_Details.vue?vue&type=template&id=031eb7c2&scoped=true"
import script from "./directInvest_Opportunities_Details.vue?vue&type=script&lang=js"
export * from "./directInvest_Opportunities_Details.vue?vue&type=script&lang=js"
import style0 from "./directInvest_Opportunities_Details.vue?vue&type=style&index=0&id=031eb7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031eb7c2",
  null
  
)

export default component.exports